import React from 'react';
import type { ButtonProps } from '../button/Button';
import { Button } from '../button/Button';

export const ModalButton = (props: ButtonProps) => {
  const buttonSize = typeof window !== 'undefined' ? (window.screen.width >= 768 ? 'L' : 'M') : 'L';
  return <Button size={buttonSize} fullWidth {...props} />;
};
